import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AuctionService } from 'src/app/data/service/auction.service';
import { UserService } from 'src/app/data/service/user.service';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        if (navigator.onLine) {
            // Grab the token from the storage and ensure it is set
            const authStr = localStorage.getItem('last-auth') || '{}';
            const authResult = JSON.parse(authStr);
            if (authResult.token != null) {

                // we need to get a community id so we can include it in request for SSO 
                // token. This could come from the auction, if there's an active auction, or
                // from the user profile as long as they have a community. If they don't have
                // a communtiy, they shouldn't see button to access CBS
                var communityId = AuctionService.communityId;
                if ( communityId > 0 == false ) {
                    communityId = UserService.communityId;
                }
                // console.log('tokenInterceptor using community id: ' + communityId)
                request = request.clone({ setHeaders: { 
                    Authorization: `Bearer ${authResult.token}`,
                    Auction: AuctionService.auctionId != null ? AuctionService.auctionId + '' : '',
                    Community: communityId != null ? communityId + '' : '' } });
            }
            return next.handle(request);
        } else {
            throw new Error('No internet connection found! Please connect to the internet and try again.');
        }
    }
}
